<template>
  <div class="BuildABox">
    <!--PAGE 2 -->
    <div v-if="(validUser && hasProducts)" class="build-wrapper no-scrollbar">
      <div class="builder-content-wrapper">
        <div class="storefront-header" :style="storefrontHeaderConfig ? 'background-color:' + storefrontHeaderConfig.color : ''" v-if="currentStep > 1">
          <div class="custom-header" v-if="showCustomHeader">
            <img :src="storefrontHeaderConfig.image"/>
            <p :style="storefrontHeaderConfig && storefrontHeaderConfig.textColor  ? 'color:' + storefrontHeaderConfig.textColor : ''">{{ storefrontHeaderConfig.text }}</p>
          </div>
        </div>
        <div id="scroll-container" class="builder-experience-container no-scrollbar" v-if="currentPage > 0">
          <div v-show="currentStep > 1" id="scroll-header" class="full-view-header" :class="currentStep == 1 ? 'step2' : ''">
            <div>
              <button @click="changePage(false)">&lt; back</button>
            </div>
            <button class="happybox-button white border filters" 
            :class="[!selectedCardsOccasions.includes('View All') ? 'selected' : '',currentStep > 2 ? 'card' : '']" 
            @click="() => {$refs.cardComponent.showFilters()}"
            >
              <img v-if="!selectedCardsOccasions.includes('View All')" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
              <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
              Filters 
              <span v-if="!selectedCardsOccasions.includes('View All')">({{ selectedCardsOccasions.length }})</span>
            </button>
            <p class="steps">
              STEP {{currentStep}} OF 3<span class="dots">:</span><span class="legend">{{ currentCopy }}</span>
              <span class="dot" :class="currentStep == 1 ? 'current' : ''">
                <span :class="1 <= currentStep ? 'selected' : ''"></span>
              </span>
              <span class="dot" :class="currentStep == 2 ? 'current' : ''">
                <span :class="2 <= currentStep ? 'selected' : ''"></span>
              </span>
              <span class="dot" :class="currentStep == 3 ? 'current' : ''">
                <span :class="3 <= currentStep ? 'selected' : ''"></span>
              </span>
            </p>
            <p class="leave-builder" v-tooltip="'Save your selections for 24 hours. Inventory subject to availability'" @click="leaveBuilder">{{headerText}} <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665" alt="save cart"></p>
          </div>
          <Page3 @leavebuilder="leaveBuilder" @changepage="changePage($event)" v-if="currentPage == 1" @gostep="goStep($event)"></Page3>
          <Page4 @changepage="changePage($event)" v-if="currentPage == 2"></Page4>
          <Page5 ref="cardComponent" @changepage="changePage($event)" @gotoaddonselection="goToAddonSelection" :user="user" :sender="sender" :currentPage="currentPage" v-show="currentPage > 2" @opencart="openCart()"></Page5>
        </div>
      </div>
      <SideCartNew 
        ref="outSideCart"
        v-show="currentStep > 1"
        :isSticking="isSticking"
        :step="currentStep"
        :fromCard="fromCard"
        @changepage="changePage($event)" 
        @bundle="bundle"
        @gostep="goStep($event)"
      />
      <OOSPopUp
      v-if="oosIsActive"
      :oosProducts="noStockItems" 
      :firstStateProducts="currentStateSelectedAddons"
      :fromSavedCart="fromSavedCart"
      :fromCurated="fromCurated"
      @goback="closeOOSPopUp"
      @continuesaved="continueSaved"
      @continuecurated="continueCurated"
      />
      <ExtraInputModal v-if="extraInputs.length > 0 && Object.keys(submittedInputs).length ===  0"/>
      <div class="global-spinner-container" v-if="nonCustomProducts.length == 0 && currentPage == 1">
        <p>amazing gifts <br class="mobile"/> are loading...</p>
        <div class="global-spinner"></div>
      </div>
    </div>
    <div v-else class="login-page">
    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_sparkle-01.png?v=1726671236" alt="Happy Box Logo" class="logo" />
    <div  class="login-container">
      <div class="login-header">
        <h2>Login to Happy Box</h2>
      </div>
      <template v-if="!loading">
        <!-- <div class="signup-prompt">
          <p>Don't have an account? <a href="#" @click="handleSignUp">Sign up</a></p>
        </div> -->
        <div class="logged-container" v-if="isLoggedIn && loggedUser">
          You are logged in as {{ loggedUser.email }} <br/> which does not have access to this collection.
          <div class="signup-prompt">
          <p><a href="#" @click="logout">Logout</a></p>
          </div>
        </div>
        <div v-if="isLoggedIn && loggedUser" class="separator">
          <span>OR LOGIN AS</span>
        </div>
        <form class="login-form" @submit.stop.prevent="handleLogin">
          <md-field :class="messageClass">
            <label>Username</label>
            <md-input id="email" v-model="email" required></md-input>
            <span class="md-error">Invalid username or password</span>
          </md-field>
          <md-field :class="messageClass">
            <label>Password</label>
            <md-input type="password" id="password" v-model="password" required></md-input>
            <span class="md-error">Invalid username or password</span>
          </md-field>
          <div class="actions">
            <!-- <a href="#" class="forgot-password" @click="handleForgotPassword">Forgot password?</a> -->
            <button :disabled="loginDisabled" type="submit" class="login-button happybox-button green border">Login</button>
          </div>
        </form>
        <div v-if="isSSO" class="separator">
          <span>OR USE</span>
        </div>
        <div v-if="isSSO" class="alternative-login">
          <button type="button" @click="login('google')" class="google-sign-in-button" >
            Sign in with Google
          </button>
          <button type="button" @click="login('microsoft')" class="google-sign-in-button microsoft" >
            Sign in with Microsoft
          </button>
        </div>
        <!-- <div class="signup-prompt">
          <p>Don't know your SSO? <a href="#" @click="handleSSOLogin">Click here</a></p>
        </div> -->
      </template>
      <div class="login-spinner" v-else>
        <div class="global-spinner"></div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import Page3 from './components/Page3.vue';
import Page4 from './components/Page4.vue';
import Page5 from './components/Page5.vue';
import OOSPopUp from './components/OOSPopUp.vue'
import SideCartNew from './components/SideCartNew.vue'
import { mapGetters } from 'vuex';
import axios from 'axios';
import ExtraInputModal from './components/Extras/ExtraInputsModal.vue'

require('dotenv').config();

export default {
  components: {
    Page3,
    Page4,
    Page5,
    OOSPopUp,
    SideCartNew,
    ExtraInputModal
  },
  watch:{
    currentPage:{
      handler(val, oldVal){
        if(val == 1 && oldVal > 1){
          this.$store.commit('updateSelectedMainProduct', null);
        }
      },
    }
  },
  data() {
    return {
      currentPage: 1,
      noStockItems: [],
      oosIsActive: false,
      fromSavedCart: false,
      fromCurated: false,
      currentStateSelectedAddons: [],
      currentTime: new Date().getTime() / 100,
      isSticking: false,
      fromCard: false,
      validUser: false,
      didValidUser: false,
      user: "",
      sender: "",
      apiUrl: "https://portal.happyboxstore.com:5054",
      email: '',
      password: '',
      user: null,
      loading: true,
      isSSO: false,
      loginError: false,
      loggedUser: null,
      isLoggedIn: false
    }
  },
  computed: {
    ...mapGetters([
      'selectedOccasion',
      'addonProducts',
      'selectedAddonProducts',
      'selectedCardsOccasions',
      'storefrontHeaderConfig',
      'boxProducts',
      'cardProducts',
      'maxCapacity',
      'extraInputs',
      'submittedInputs',
      'hasHBProducts',
      'totalAddons'
    ]),
    messageClass () {
      return {
        'md-invalid': this.loginError
      }
    },
    hasProducts(){
      return this.addonProducts.length > 0;
    },
    nonCustomProducts(){
      return this.totalAddons.filter(x => !x.tags.includes(`Filter_Category_${this.user} Gifts`));
    },
    showCustomHeader(){
      return this.storefrontHeaderConfig && this.storefrontHeaderConfig.color && this.storefrontHeaderConfig.image;
    },
    currentStep(){
      if(this.currentPage < 4)
        return this.currentPage;
      else {
        return 3
      }
    },
    currentCopy(){
      if(this.currentPage > 2){
        return "Pick a card design!"
      }
      else if(this.currentPage == 2){
        return "Pick a box design!"
      }

      return ""
    },
    headerText(){
      return "SAVE"
    },
    breadcrumbText(){
      return `All products > ${this.selectedOccasion}`
    },
    loginDisabled(){
      return this.email == "" || this.password == "";
    }
  },
  methods: {
    changePage(increment) {
      document.getElementById('PageContainer')?.scrollTo({ top: 0, behavior: 'auto' });
      if(increment){
        if(this.currentPage == 1){
            this.currentPage++;
        }
        else
          this.currentPage++;
      }
      else{
        this.currentPage--;
      }
    },
    goToAddonSelection(){
      this.currentPage = 1;
    },
    goStep(event){
      this.currentPage = event;
    },
    leaveBuilder(){
      var localProducts = this.selectedAddonProducts.filter(x => x.tags.every(x => !x.includes("QTYMIN"))).map((x) => {
        return {id: x.id ,v:x.variants[0].id,q: x.quantity}
      });
      localStorage.setItem('totalAddons',JSON.stringify(localProducts));
    },
    adjustHeaderandFooter(){
      const buildBox = document.getElementById('build-a-box');
      if(this.currentPage > 1){
        if (buildBox) buildBox.style.overflow = 'hidden';
      }
      else {
        if (buildBox) buildBox.style.overflow = 'auto';
      }
    },
    validateUser(){
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const token = urlParams.get('user')
      if(!token){
        this.didValidUser = true;
        return;
      }
      const corporateUrl = `${this.apiUrl}/corporate/tokenSite`;
      fetch(corporateUrl,{
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
        },
        body: JSON.stringify({collection:window.location.pathname}) // body data type must match "Content-Type" header
      })
      .then(data => {return data.json()})
      .then(res => {
        if(res.valid){
          this.user = res.user;
          this.$store.commit('setCorpName', this.user);
          this.sender = res.sender;
          this.$store.commit('setBoxName', `${res.user} Box`);
          this.getProducts(res.products,res.handle);
          this.$store.commit('setStorefrontHeaderConfig',res.config);
          this.$store.commit('setMessages',res.messages);
          this.$store.commit('setConfiguration',res.configuration);
          if(res.budget){
            this.$store.commit('setBudget', res.budget);
          }
        }
        else
        {
          this.validUser = false;
          this.didValidUser = true;
        }
      })
    },
    async getProducts(products,handle){
     let response = await axios.get(`/collections/${handle}/products.json?limit=250`)
     if(response.data){
      this.sortFetchedProducts(response.data.products,products);
     }
    },
    async sortFetchedProducts(totalProductList,data) {
      totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
      var addonProductList = totalProductList.filter((product) => {
        if(!product.tags.includes("Box") && !product.tags.includes("Card") && !product.tags.includes("handpacking_fee")   && product.variants.some(x => x.inventory_quantity > 0)) {
          product.tags = product.tags.split(', ')
          product.tags.push(`Filter_Category_${this.user} Gifts`)
          const capacityTag = product.tags.find(tag => tag.indexOf('Capacity_') > -1);
          if (capacityTag != undefined) {
            const capacity = parseFloat(capacityTag.split('_')[1]);
            product.capacity = capacity;
          }
          const { tags } = product;
          const hasShowPrice = tags.some(tag => tag.includes("show_price"));
          let priceTag = "";
          if(hasShowPrice) {
            priceTag = tags.find(tag => tag.includes("Price_"));
          }
          product.variants = product.variants.map((variant) =>{
            variant.available = variant.inventory_quantity > 0;
            variant.featured_image = product.images.find(x => x.id == variant.image_id);
            if(hasShowPrice){
              variant.value_price = priceTag.split("_").pop();
            }
            return variant
          });
          product.corporate = true;

          return product;
        }
      });

      this.$store.commit('setAddonProducts', JSON.parse(JSON.stringify(this.addonProducts.concat(addonProductList))));
      this.getBoxProduct(totalProductList);
    },
    getBoxProduct(product) {
      let boxProduct = product.filter((product) => {
        if (product.tags.includes("Box") && product.variants.some(x => x.inventory_quantity > 0 || x.inventory_policy == "continue")) {
        product.maxCapacity = parseInt(product.variants[0].option1);
        product.variants = product.variants.map((variant) =>{
          variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity;
          variant.available = variant.inventory_quantity > 0;
          return variant
        })
        product.corporate = true;
        return product;
        }
      });
      this.$store.commit('setMainProducts',JSON.parse(JSON.stringify(boxProduct.concat(this.boxProducts))));
      let cardProduct = product.filter((product) => {
        if (product.tags.includes("Card") && product.variants.some(x => x.inventory_quantity > 0 || x.inventory_policy == "continue")) {
        product.variants = product.variants.map((variant) =>{
          variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity;
          variant.available = variant.inventory_quantity > 0;
          return variant
        })
        product.corporate = true;
        return product;
        }
      });
      this.$store.commit('setCardProducts',JSON.parse(JSON.stringify(cardProduct.concat(this.cardProducts))));
      var capacityList = boxProduct.map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1));
      let maxCapacity = Math.max(...capacityList);
      if(this.maxCapacity < maxCapacity){
        this.$store.commit('setMaxCapacity', maxCapacity);
      }
      this.validUser = true;
      this.didValidUser = true;
      //get fee product
      let feeProduct = product.find((product) => product.tags.includes("handpacking_fee"));
      if(feeProduct){
        this.$store.commit('setFeeProduct', feeProduct);
      }
    },
    closeOOSPopUp(){
      this.fromSavedCart = false;
      this.fromCurated = false;
      this.noStockItems = [];
      this.oosIsActive = false;
      this.currentStateSelectedAddons = [];
    },
    continueSaved(){
      this.closeOOSPopUp();
      this.currentPage = 3;
    },
    continueCurated(){
      this.closeOOSPopUp();
      this.changePage(true);
    },
    oosCurated(event){
      this.currentStateSelectedAddons = JSON.parse(JSON.stringify(this.selectedAddonProducts));
      this.fromSavedCart = false;
      this.fromCurated = true;
      this.noStockItems = event;
      this.oosIsActive = true;
    },
    openCart(){
      this.fromCard = true;
      this.$refs.outSideCart.expandCart(true);
    },
    bundle(){
      this.$refs.cardComponent.bundle();
    },
    async handleLogin() {
      const corporateUrl = `${this.apiUrl}/sso/login`;
      this.loading = true;
      this.loginError = false;
      try{
        let res = await axios.post(corporateUrl,{url:window.location.pathname,email:this.email,password:this.password})
        res = res?.data;
        if(res.valid){
          this.user = res.user;
          this.$store.commit('setCorpName', this.user);
          this.sender = res.sender;
          this.$store.commit('setBoxName', `${res.user} Box`);
          this.getProducts(res.products,res.handle);
          this.$store.commit('setStorefrontHeaderConfig',res.config);
          this.$store.commit('setMessages',res.messages);
          this.$store.commit('setConfiguration',res.configuration);
          if(res.budget){
            this.$store.commit('setBudget', res.budget);
          }
        }
      }
      catch (error) {
        this.loginError = true;
        this.loading = false;
      }
    },
    async checkUser() {
      try {
        const returnUrl = window.location.href;
        const response = await axios.get(`https://api.happyboxstore.com/api/sso/me?url=${encodeURIComponent(returnUrl)}`,{ withCredentials: true });
        let res = response?.data;
        if(res.valid){
          this.user = res.user;
          this.$store.commit('setCorpName', this.user);
          this.sender = res.sender;
          this.$store.commit('setBoxName', `${res.user} Box`);
          this.getProducts(res.products,res.handle);
          this.$store.commit('setStorefrontHeaderConfig',res.config);
          this.$store.commit('setMessages',res.messages);
          this.$store.commit('setConfiguration',res.configuration);
          if(res.budget){
            this.$store.commit('setBudget', res.budget);
          }
        }
        else{
          if(res.user){
            this.loggedUser = res.user;
            this.isLoggedIn = true;
          }
          this.loading = false;
        }
        
      } catch (error) {
        console.error('Error fetching user info:', error);
        this.loading = false;
      }
    },
    login(provider) {
      // Use the current window location as the returnUrl
      const returnUrl = window.location.href;
      // Redirect the browser to the backend SSO login endpoint
      window.location.href = `https://api.happyboxstore.com/api/sso/login?provider=${provider}&returnUrl=${encodeURIComponent(returnUrl)}`;
    },
    async logout() {
      try {
        await axios.get('https://api.happyboxstore.com/api/sso/logout',{ withCredentials: true });
        this.loggedUser = null;
        this.isLoggedIn = false;
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
  },
  mounted() {
    let isSSO = document.getElementById("SSO");
    this.isSSO = isSSO != null;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('user');
    if(token || location.pathname == "/collections/custom-builder"){
      this.validateUser();
    }
    else
      this.checkUser();
  },
  updated(){
    if(this.validUser && this.hasProducts){
      var that = this;
      var element = document.getElementById("scroll-header");
        var root = document.querySelector(".build-wrapper");
        var observer = new IntersectionObserver(function(entries) {
            if(entries[0].intersectionRatio < 1){
                setTimeout(function(){
                    that.isSticking = true;
                }, 200);
            }
            else{
                setTimeout(function(){
                    that.isSticking = false;
                }, 200);
            }
        }, { threshold: [0,1],root: root });

        observer.observe(element);
    }
  }
}
</script>

<style scoped>

.storefront-header{
    display: flex;
    width: 100%;
    justify-content: center;
    padding-right: 10%;
    height: 10vh;
}

.custom-header img{
    height: 50%;
    width: auto;
}

.custom-header{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 65%;
    gap: 5%;
}

.custom-header p{
    color: white;
    font-family: Founders Grotesk, sans-serif;
    font-size: 3vw;
}
.builder-header{
  width: 100%;
  position: relative;
}

.builder-header .header-main{
  width: 100%;
}

.builder-header .floating-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
}

.builder-header.box .floating-container{
  left: 30%;
  width: 20%;
}

.builder-header.card .floating-container{
  left: 30%;
  width: 20%;
  transform: rotate(5deg);
}

.builder-header.card .floating-container .arrow-4{
  position: absolute;
  bottom: 15%;
  width: 5%;
  transform: rotate(50deg) scaleX(-1);
  left: 5%;
}

.builder-header.box .floating-container .arrow-1{
  position: absolute;
  width: 5%;
  transform: rotate(115deg);
  left: 20%;
  top: 30%;
}

.builder-header.box .floating-container .arrow-2{
  position: absolute;
  width: 5%;
  transform: rotate(90deg);
  left: 17%;
  bottom: 25%;
}

.builder-header.box .floating-container .arrow-3{
  position: absolute;
  width: 5%;
  transform: rotate(-90deg);
  right: 17%;
  bottom: 30%;
}

.builder-header .floating-container .title{
  font-size: 3vw;
  line-height: .5;
  font-family: Palmer Lake Print;
  text-align: center;
}

@media screen and (max-width: 767px){
  .builder-header .floating-container .title{
    font-size: 8vw;
  }

  .builder-header.box .floating-container{
    left: 50%;
    justify-content: flex-start;
    padding-top: 7%;
    transform: rotate(5deg);
  }

  .builder-header.box .floating-container .arrow-1{
    width: 12.5%;
    left: -25%;
    top: 35%;
    transform: rotate(90deg);
  }
  .builder-header.box .floating-container .arrow-2{
    width: 12.5%;
    bottom: 15%;
    left: 35%;
    transform: rotate(15deg) scaleX(-1);
  }
  .builder-header.box .floating-container .arrow-3{
    width: 12.5%;
    right: -20%;
    bottom: unset;
    top: 25%;
  }

  .builder-header.card .floating-container{
    left: 35%;
    width: 50%;
    transform: rotate(5deg);
    padding-top: 5%;
    justify-content: flex-start;
  }

  .builder-header.card .floating-container .arrow-4{
    left: 15%;
    width: 7%;
    transform: rotate(40deg) scaleX(-1);
  }
}


</style>

<style>
.build-wrapper{
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  overflow-x: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 1001;
  overflow-y: scroll
}

.builder-content-wrapper{
  width: 100%;
}
#shopify-section-footer{
  display: none;
}
.global-spinner-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.3);
  position: fixed;
  height: 100%;
  z-index: 100;
  top: 0;
  right: 0;
  left: 0;
}

.global-spinner-container p{
  font-size: 32px;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

.promotion{
  width: 100%;
  position: relative;
}

.promotion img{
  width: 100%;
  border-radius: 8px;
}

.promotion .floating-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 5%;
}

.promotion .floating-container .title{
  font-size: 2.5vw;
  font-family: Founders Grotesk,sans-serif;
  line-height: 1;
  color: #fff;
  padding-right: 12%;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle{
  font-size: 1vw;
  color: white;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle span{
  font-style: italic;
  color: white;
}

.promotion .floating-container .happybox-button{
  width: 100%;
}

.builder-header .breadcrumb{
  color: #0f0c38;
  text-decoration: underline;
  position: absolute;
  top: 0%;
  left: 5%;
  z-index: 1;
  display: none;
}

.builder-header .breadcrumb > * {
  color: #0f0c38;
  text-decoration: underline;
  font-weight: bold;
}

.login-form input{
  height: unset !important;
  padding: unset !important;
  border: unset !important;
  border-bottom: 1px solid black !important;
}

.login-page {
  padding: 5%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ebeeff;
  min-height: calc(100vh - 90px);
}

.login-container {
  padding: 40px;
  border: 1px solid #ddd;
  border-radius: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: white;
  min-width: 350px;
  border: 1px solid #0f0c38;
}

.login-spinner{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-header {
  text-align: center;
}

.login-header h2{
  font-family: Founders Grotesk, sans-serif;
  font-size: 3vw;
}

.logo {
  max-width: 100px;
  margin-bottom: 10px;
}

.input-group {
  margin-bottom: 15px;
}

.input-group label {
  display: block;
  margin-bottom: 5px;
}

.input-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.login-button {
  width: 100%;
  margin: unset;
  margin-top: 1rem;
}

.login-button:disabled{
  background-color: rgb(242, 244, 246);
  opacity: 0.7;
}

.forgot-password {
  font-size: 1vw;
  text-align: right;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  color: #0f0c38;
}

.alternative-login {
  text-align: center;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.alternative-login p {
  margin-bottom: 10px;
}

.signup-prompt {
  text-align: center;
  color: #0f0c38;
  font-size: 1vw;
}

.signup-prompt a {
  color: #7f38d0;
  text-decoration: underline;
  cursor: pointer;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #ccc;
  margin: 5px;
}

.separator span {
  padding: 0 10px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(15,12,56,0.7);
}

.google-sign-in-button {
    cursor: pointer;
    transition: background-color .3s, box-shadow .3s;
        
    padding: 2% 42px;
    border: none;
    border-radius: 16px;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25);
    
    color: #757575;
    font-size: 14px;
    font-weight: 500;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
    background-color: white;
    background-repeat: no-repeat;
    background-position: 12px 45%;
    border: 1px solid #0F0C38;
}
.google-sign-in-button.microsoft{
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGl0bGU+TVMtU3ltYm9sTG9ja3VwPC90aXRsZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iOSIgaGVpZ2h0PSI5IiBmaWxsPSIjZjI1MDIyIi8+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgeD0iMSIgeT0iMTEiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIGZpbGw9IiMwMGE0ZWYiLz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMSIgeT0iMSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgZmlsbD0iIzdmYmEwMCIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IHg9IjExIiB5PSIxMSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgZmlsbD0iI2ZmYjkwMCIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9zdmc+);
  border-radius: 4px;
  color: white;
  background-color: black;
}
.google-sign-in-button.microsoft:hover{
  color: black;
}
.google-sign-in-button:hover {
  background-color: rgb(240, 240, 240);
}

.google-sign-in-button:active {
    background-color: #eeeeee;
}

.google-sign-in-button:active {
    outline: none;
        box-shadow: 
        0 -1px 0 rgba(0, 0, 0, .04),
        0 2px 4px rgba(0, 0, 0, .25),
        0 0 0 3px #c8dafc;
}

.md-field.md-invalid .md-error{
  color: red;
}

.logged-container{
  font-size: 1vw;
  color: red;
}

@media screen and (max-width: 767px){
  .global-spinner-container p{
    font-size: 27px;
  }
  .promotion img{
    height: 100%;
    object-fit: cover;
  }

  .promotion .floating-container .happybox-button{
    width: 100%;
    padding: 2%;
  }

  .promotion .floating-container .title{
    font-size: 5vw;
    width: 100%;
  }

  .promotion .floating-container .subtitle{
    font-size: 2vw;
    width: 100%;
    text-align: left;
  }

  .builder-header .breadcrumb{
    top: 7.5%;
    display: block;
  }
}
</style>